import { Link } from 'react-router-dom';
import useSectionAnimation from '@/hooks/useSectionAnimation';

const CtaSection = () => {
  const { ref, fadeUp } = useSectionAnimation({ threshold: 0.1 });

  return (
    <section ref={ref} className="py-20 bg-white" dir="rtl">
      <div className="max-w-7xl mx-auto px-8 md:px-12" style={fadeUp}>
        <div className="relative overflow-hidden rounded-3xl bg-emerald-600">
          <img
            src="https://readdy.ai/api/search-image?query=Saudi%20Arabia%20community%20celebration%20success%20achievement%20warm%20golden%20light%20people%20together%20inspiring&width=1400&height=600&seq=501&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
          />
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 p-10 md:p-16">
            <div className="text-center lg:text-right">
              <h2 className="text-2xl md:text-5xl font-black text-white leading-tight mb-4">
                جاهز لإطلاق
                <br />
                <span className="text-emerald-200">حملتك؟</span>
              </h2>
              <p className="text-emerald-100 text-lg max-w-md">
                انضم لآلاف المبدعين وأصحاب القضايا الذين وجدوا دعمهم عبر هِبة في المدينة المنورة والمملكة. ابدأ حملتك اليوم.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 shrink-0">
              <Link
                to="/create"
                className="inline-flex items-center justify-center gap-2 bg-white text-emerald-700 font-bold px-8 py-4 rounded-full hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-add-circle-line"></i>
                ابدأ حملتك الآن
              </Link>
              <Link
                to="/explore"
                className="inline-flex items-center justify-center gap-2 bg-emerald-700/50 border border-white/30 text-white font-bold px-8 py-4 rounded-full hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-compass-3-line"></i>
                استكشف الحملات
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
